import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  statusData: [],
};

export const statusSlice = createSlice({
  name: "status",
  initialState,
  reducers: {
    fetchStatus: (state, action) => {
      state.statusData = action.payload;
    },
  },
});

export const { fetchStatus } = statusSlice.actions;

const statusListingSliceReducer = statusSlice.reducer;

export default statusListingSliceReducer;
